<template>
  <b-tabs
    pills
    fill
  >
    <b-tab active>
      <template #title>
        <feather-icon icon="TruckIcon" />
        <span>Servis Bilgileri</span>
      </template>
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <service-card />
        </b-col>
        <b-col
          cols="12"
          md="9"
        >
          <service-works :refresh-works="serviceWorks" />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab lazy>
      <template #title>
        <FeatherIcon icon="BoxIcon" />
        <span>Kullanılan Malzemeler</span>
      </template>
      <material-list />
    </b-tab>
    <b-tab lazy>
      <template #title>
        <FeatherIcon icon="UsersIcon" />
        <span>Müşteri Bilgileri</span>
      </template>
      <customer-card />
    </b-tab>
  </b-tabs>
</template>
<script>
import {
  BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import CustomerCard from '@/views/Services/CustomerCard.vue'
import ServiceCard from '@/views/Services/View/ServiceCard.vue'
import ServiceWorks from '@/views/Services/View/ServiceWorks.vue'
import MaterialList from '@/views/Services/View/MaterialList.vue'

export default {
  name: 'ServiceView',
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    CustomerCard,
    ServiceCard,
    ServiceWorks,
    MaterialList,
  },
  created() {
    this.getData()
    this.serviceWorks()
  },
  methods: {
    getData() {
      this.$store.dispatch('services/getDataItem', this.$route.params.id)
        .then(response => {
          if (response.id_customers) {
            this.$store.dispatch('customers/customerView', response.id_customers)
          }
        })
    },
    serviceWorks() {
      this.getData()
      this.$store.dispatch('serviceWorks/getDataList', {
        where: {
          'service_works.id_services': this.$route.params.id,
        },
        images: true,
        workers: true,
      })
    },
  },
}
</script>
